/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Moderation_TipInputs */

const en_moderation_tip = /** @type {(inputs: Moderation_TipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`As an owner, you can purge any message to keep the community safe. Automated image scanning is active.`)
};

const id_moderation_tip = /** @type {(inputs: Moderation_TipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sebagai pemilik, Anda dapat menghapus tuntas pesan apa pun agar komunitas tetap aman. Pemindaian gambar otomatis aktif.`)
};

/** @type {(inputs: Moderation_TipInputs) => LocalizedString} */
const es_moderation_tip = en_moderation_tip;

/** @type {(inputs: Moderation_TipInputs) => LocalizedString} */
const fr_moderation_tip = en_moderation_tip;

/** @type {(inputs: Moderation_TipInputs) => LocalizedString} */
const de_moderation_tip = en_moderation_tip;

/** @type {(inputs: Moderation_TipInputs) => LocalizedString} */
const ja_moderation_tip = en_moderation_tip;

/** @type {(inputs: Moderation_TipInputs) => LocalizedString} */
const zh_moderation_tip = en_moderation_tip;

/** @type {(inputs: Moderation_TipInputs) => LocalizedString} */
const ar_moderation_tip = en_moderation_tip;

/** @type {(inputs: Moderation_TipInputs) => LocalizedString} */
const it_moderation_tip = en_moderation_tip;

/** @type {(inputs: Moderation_TipInputs) => LocalizedString} */
const ru_moderation_tip = en_moderation_tip;

/** @type {(inputs: Moderation_TipInputs) => LocalizedString} */
const pt_moderation_tip = en_moderation_tip;

/** @type {(inputs: Moderation_TipInputs) => LocalizedString} */
const ko_moderation_tip = en_moderation_tip;

/**
* | output |
* | --- |
* | "As an owner, you can purge any message to keep the community safe. Automated image scanning is active." |
*
* @param {Moderation_TipInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const moderation_tip = /** @type {((inputs?: Moderation_TipInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Moderation_TipInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_moderation_tip(inputs)
	if (locale === "es") return es_moderation_tip(inputs)
	if (locale === "fr") return fr_moderation_tip(inputs)
	if (locale === "de") return de_moderation_tip(inputs)
	if (locale === "ja") return ja_moderation_tip(inputs)
	if (locale === "zh") return zh_moderation_tip(inputs)
	if (locale === "ar") return ar_moderation_tip(inputs)
	if (locale === "id") return id_moderation_tip(inputs)
	if (locale === "it") return it_moderation_tip(inputs)
	if (locale === "ru") return ru_moderation_tip(inputs)
	if (locale === "pt") return pt_moderation_tip(inputs)
	return ko_moderation_tip(inputs)
});